<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择库区"
      width="900px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="warehouseAreas"
        @select="selectWarehouseArea"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="编号" prop="warehouseAreaNo">
            <el-input v-model.trim="filter.warehouseAreaNo" placeholder="请输入库区编号" clearable/>
          </el-form-item>
          <el-form-item label="名称" prop="warehouseAreaName">
            <el-input v-model.trim="filter.warehouseAreaName" placeholder="请输入库区名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          no: "",
          name: "",
          mrpType: "",
        },
        columns: [
          {
            title: "仓库名称",
            key: "warehouseName",
          },
          {
            title: "库区编号",
            key: "warehouseAreaNo",
            width: 120,
            align: "center",
          },
          {
            title: "库区名称",
            key: "warehouseAreaName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectWarehouseArea(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
